import React from 'react';
import styled from 'styled-components';
import LightSpeed from 'react-reveal/LightSpeed';

const Container = styled.section`
  img {
    border-radius: 4px;
    object-fit: cover;
    object-position: top;
  }
`;

const WeddingCulture = ({ data }) => {
  return (
    <Container className="section">
      <div className="columns is-centered">
        <div className="column is-7">
          <LightSpeed right cascade>
            <h1 className="title is-3 has-text-black has-text-centered">
              {data.homeHeroAbout.title}
            </h1>
            <p className="has-text-black has-text-centered">
              {data.homeHeroAbout.subtitle}
            </p>
          </LightSpeed>
        </div>
      </div>
      <div className="container">
        <figure className="image is-3by1">
          <img src={data.homeHeroAbout.image.asset.fluid.src} alt="" />
        </figure>
      </div>
    </Container>
  );
};

export default WeddingCulture;
